import { Grid } from "@mui/material";
import { INVESTMENT_TYPE } from "./constants";
import TableFloating from "./TableFloating";
import { useSearchParams } from "react-router-dom";
// import ComingSoon from "components/ComingSoon";
import TableFixed from "./TableFixed";


function InvestmentTable({ setCreateInvestmentKey }) {
  const [searchParams] = useSearchParams()
  const investmentTab = +searchParams.get("investmentTab") || 1

  return (
    <Grid container spacing={1} mt={0}>
      <Grid item xs={12}>
        {investmentTab === INVESTMENT_TYPE.floating.key && <TableFloating setCreateInvestmentKey={setCreateInvestmentKey} />}
        {investmentTab === INVESTMENT_TYPE.fixed.key && <TableFixed setCreateInvestmentKey={setCreateInvestmentKey} />}
        {/* {investmentTab === INVESTMENT_TYPE.fixed.key && <ComingSoon />} */}
      </Grid>
    </Grid>
  );
}

export default InvestmentTable;
